import { Outlet } from "react-router";
import NavbarHomeLanding from './navbars/NavbarHomeLanding';
import FooterWithLinks from "./footers/FooterWithLinks";

const HomeLayout = () => {
    return (
        <>
            <NavbarHomeLanding />
            <Outlet />
            <FooterWithLinks />
        </>
    );
};

export default HomeLayout;